import { useNavigate } from "react-router-dom";

import axios from 'axios';
import storages from '../helper/storages'
import useEndpoints from "../api/useEndpoints";
import errorHandler from "../api/errorHandler";
import { useState, useRef } from "react";

import Toast from './toast'
import paths from '../config/paths.json'
import { FaArrowLeft } from 'react-icons/fa';
import { AiOutlineEyeInvisible, AiOutlineEye } from 'react-icons/ai'
import Captcha from "./captcha";
import loader from "../modals/loaderModal";
import LoginHeader from "./loginHeader";
import { fa2En } from '../helper/InputHelper'
import { useMediaQuery } from 'react-responsive'

export default function RecoveryPassword() {
    const endpoints = useEndpoints();
    const navigate = useNavigate();
    const [state, setState] = useState()
    const [loading, setLoading] = useState(false)
    const isMobile = useMediaQuery({ query: `(max-width: 767px)` });
    var logo = require(`../assets/images/${process.env.REACT_APP_ENV}/logo.png`)
    var bg_sm = require(`../assets/images/${process.env.REACT_APP_ENV}/bg-sm.jpg`)
    var bg_lg = require(`../assets/images/${process.env.REACT_APP_ENV}/bg-lg.jpg`)
  
    var onLoginPress = () => {
        setLoading(true)
        axios.get(endpoints.forgetPassword,
            {
                params:
                {
                    mobile: fa2En(state?.mobile)
                }
            }, {
            headers: { 'x-auth-token': storages.getUserToken() },
        }).then((res) => {
            setLoading(false)
            console.log(res.data)

            Toast.Success(res.data.result.desciption)
            navigate(paths.login);
        }).catch((e) => {
            setLoading(false)
            errorHandler(e)
        })
    }



    let onInputChange = (e) => {
        try {
            let name = e.target.name;
            let value = e.target.value;
            setState((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        } catch (e) {
            console.log(e);
        }
    };


    return (

        <>
            <div className="w-100 vh-100 position-absolute bg-dark align-items-center overflow-hidden  justify-content-center d-flex ">
                {
                    isMobile ?
                        <img className="center-cropped " src={bg_sm} />
                        :
                        <img className="  center-cropped " src={bg_lg} />


                }

            </div>

            <div className=" position-absolute d-flex col-12  justify-content-center align-items-center  p-3">
                <div className="d-flex me-auto"
                    style={{ cursor: 'pointer' }}
                    onClick={() => navigate(-1)}>
                    <p className="p-0 m-0  iranSansBold text-light ms-2" >بازگشت</p>

                    <FaArrowLeft className="bg-dark p-0 m-0 text-light " size={27} />
                </div>

            </div>

            <div className="d-flex justify-content-center align-items-center bg-dark vh-100 overflow-auto" style={{ top: 0, right: 0, bottom: 0, left: 0 }} >

                <div className="d-flex flex-column justify-content-center align-items-center  ">

                    <LoginHeader />

                    <div className="card p-3 col-12 " autoComplete="on"  >
                        <div className="d-flex w-100 justify-content-center align-items-center trans ">
                            <img style={{ width: '9rem' }} className="position-absolute top-0 mt-2 start-50 translate-middle" src={logo} />
                        </div>
                        <h5 className="justify-content-center align-items-center d-flex iranSansBold mt-5">صفحه بازیابی کلمه عبور</h5>

                        <div className="form-group pt-4 autocomp">
                            <label htmlFor="mobile" className="pb-1">جهت بازیابی اطلاعات ورود شماره همراه خود را وارد نمایید</label>
                            <input className="form-control" name="mobile" placeholder="شماره همراه" onChange={onInputChange} />
                        </div>

                        {

                            loading ?
                                <div className="col-12  justify-content-center align-items-center d-flex mt-2">
                                    <div className="spinner-border text-success " />
                                </div>
                                :
                                <button to="/"
                                    className="btn btn-success iranSansBold col-12 mt-2 arcaptcha"
                                    onClick={onLoginPress}
                                >ثبت درخواست</button>
                        }


                    </div>
                    <small className="form-text text-muted ">1401 © توسعه و اجرا توسط شرکت <a href="http://efspco.ir" target="_blank">ابتکار فناوران سهند پویا</a> </small>

                </div>


            </div>

        </>


    );

}